import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import type { WPublicNavItemView } from '@zola/svc-web-api-ts-client';
import { fillFontProperties, mapFullFontViewToSerializedStyles } from '../../../util/mappers';
import { ThemeContext } from '../../../context';
import { NavItem, NavLinkContainer, NavContainer } from './NavigationMenu.styles';
import getPublicWebsiteHref from '../../../util/getPublicWebsiteHref';

export type NavigationMenuProps = {
  navItems?: WPublicNavItemView[];
  slug?: string;
  className?: string;
  topOffset: number;
  isAnimating: boolean;
};

const NavigationMenu = ({
  navItems,
  slug,
  className,
  topOffset,
  isAnimating,
}: NavigationMenuProps): JSX.Element => {
  const router = useRouter();
  const { pageType = 'home' } = router?.query || {};
  const {
    wedding,
    components: { globalBodyFontValues },
    inPreview,
  } = useContext(ThemeContext);
  const { public_theme_v2 } = wedding || {};
  const navBodyFontStyles = public_theme_v2?.components?.NAV?.fonts?.BODY?.[1];
  const navBodyFontStylesFinal = fillFontProperties(globalBodyFontValues, navBodyFontStyles);

  return (
    <NavContainer
      className={className}
      topOffset={topOffset}
      isAnimating={isAnimating}
      inPreview={inPreview}
    >
      <NavLinkContainer>
        {(navItems || []).map(({ type, nav_title, id }) => {
          const typeLower = ((type as unknown) as string).toLowerCase();
          return type ? (
            <NavItem
              href={getPublicWebsiteHref(slug, typeLower, router?.query)}
              key={id}
              css={mapFullFontViewToSerializedStyles(navBodyFontStylesFinal)}
              linkColor={navBodyFontStylesFinal?.color}
              active={pageType === typeLower}
            >
              {nav_title}
            </NavItem>
          ) : null;
        })}
      </NavLinkContainer>
    </NavContainer>
  );
};

export default NavigationMenu;
